export default "__VITE_ASSET__C77r_Ts___"